module.exports = __webpack_public_path__ + "img/blog-14-2.e4adb81f.webp";